import React from 'react';
import FeatureCards from "../../../../components/FeatureCards/FeatureCards";
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import LocationTimeline from "../../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../../components/ServiceCards/ServiceCards";

export default function FinTechPaymentsLicensePanama() {

    return (
        <main className='main'>
            <IntroSection
                title="FinTech & Payments License – Panama"
                subtitle="Launch Your FinTech or Payment Services in Latin America"
                description="Panama is a growing hub for fintech, payment processing, and remittance businesses. While it does not operate under the EU PSD2 framework, it offers flexible licensing regimes through the Ministry of Commerce & Industries and financial supervision authorities. With its territorial tax system (no tax on foreign-sourced income) and strong financial tradition, Panama is ideal for fintech companies targeting LatAm, MENA, and Asia-Pacific clients."
                badges={[
                    "Remittance Services",
                    "Payment Processing",
                    "Merchant Acquiring",
                    "Digital Wallets",
                    "Crypto Gateways"
                ]}
                buttonText="Request a Panama Payments Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../../assets/images/services/payments-fintech-license-panama-hero.png")}
                imageAlt="Panama FinTech & Payments"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Panama for FinTech & Payments?'
                        blocks={[
                            {
                                items: [
                                    {
                                        title: "Strategic Location",
                                        text: "Gateway between North & South America."
                                    },
                                    {
                                        title: "Flexible Licensing",
                                        text: "Easier setup compared to strict EU EMI/PSD2 frameworks."
                                    },
                                    {
                                        title: "Low Capital Entry",
                                        text: "Lower initial requirements than Malta or Cyprus."
                                    },
                                    {
                                        title: "Crypto-Friendly",
                                        text: "Progressive digital asset law introduced in 2022."
                                    },
                                    {
                                        title: "Tax Advantages",
                                        text: "Territorial tax system — foreign income is exempt."
                                    },
                                    {
                                        title: "Regional Hub",
                                        text: "High demand for cross-border payment services in Latin America."
                                    }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Types of FinTech/Payment Licenses in Panama"
                        blocks={[
                            {
                                title: "Money Service Business (MSB) / Remittance Company",
                                items: [
                                    { text: "Registered with the Ministry of Commerce & Industries." },
                                    { text: "Allows cross-border remittances, merchant acquiring, and money transfer." },
                                    { text: "Capital Requirement: Typically USD 100,000–250,000 depending on scale." }
                                ]
                            },
                            {
                                title: "FinTech & Payment Processing Platforms",
                                items: [
                                    { text: "Licensed as financial service providers under commercial law." },
                                    { text: "Can operate payment gateways, wallets, and merchant solutions." },
                                    { text: "Popular with PSPs targeting Latin American merchants." }
                                ]
                            },
                            {
                                title: "Crypto-Payment Integrations",
                                items: [
                                    { text: "Covered under Panama’s 2022 Digital Asset Law." },
                                    { text: "Supports crypto-to-fiat gateways, wallets, and exchanges." },
                                    { text: "Registration required with ISR-SNF regulator." }
                                ]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="Services Covered by a Panama FinTech/Payment License"
                        item={[
                            {
                                title: "Cross-Border Remittances",
                                text: "Enable regional and international money transfer."
                            },
                            {
                                title: "Merchant Acquiring",
                                text: "E-commerce and POS payment processing."
                            },
                            {
                                title: "Digital Wallets",
                                text: "Supports stored value, balances, and payments."
                            },
                            {
                                title: "Prepaid Cards",
                                text: "Issued via partnerships with local banks."
                            },
                            {
                                title: "Crypto Gateways",
                                text: "Hybrid PSP models offering crypto-to-fiat rails."
                            }
                        ]}
                    />

                    <ServiceCards
                        title="Benefits of a Panama FinTech License"
                        services={[
                            {
                                title: "Regional Recognition",
                                text: "Trusted framework for serving Latin American markets."
                            },
                            {
                                title: "Lighter Compliance",
                                text: "Less restrictive than EU EMI licensing regimes."
                            },
                            {
                                title: "Banking Partnerships",
                                text: "Access to Panama’s strong and stable banking network."
                            },
                            {
                                title: "Crypto Integration",
                                text: "Digital asset-friendly environment for hybrid PSPs."
                            },
                            {
                                title: "Fast Setup",
                                text: "Licensing within 3–6 months versus 9–12 months in the EU."
                            }
                        ]}
                    />

                    <FeatureCards
                        title="Licensing Process"
                        features={[
                            {
                                title: "Consultation & Planning",
                                text: "Define the operating model (PSP, MSB, crypto gateway)."
                            },
                            {
                                title: "Company Incorporation",
                                text: "Register a Panama legal entity."
                            },
                            {
                                title: "Application Submission",
                                text: "Prepare business plan, AML/KYC framework, and financial documentation."
                            },
                            {
                                title: "Regulatory Review",
                                text: "Due diligence by the Ministry of Commerce or ISR-SNF."
                            },
                            {
                                title: "Approval & Registration",
                                text: "Final authorization typically issued within 3–6 months."
                            }
                        ]}
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "3–6 months",
                            },
                            {
                                name: "Setup Costs",
                                description: "From USD 50,000+ (legal, compliance, licensing)",
                            },
                            {
                                name: "Capital Requirement",
                                description: "USD 100k–250k (depending on services)",
                            },
                            {
                                name: "Annual Costs",
                                description: "Compliance, audits, government fees",
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Specialists in Panama fintech and payment licensing" },
                                { text: "End-to-end services: incorporation, registration, compliance manuals" },
                                { text: "Introductions to banks, PSPs, card issuers, and processors" },
                                { text: "Advice on hybrid payment and crypto structures" },
                                { text: "Balanced comparison: Panama vs Malta vs Cyprus vs Offshore EMIs" }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to launch a fintech or payment business in LatAm?"
                        description="Panama offers flexible fintech licensing, fast setup, and crypto integration, making it an ideal choice for payment platforms and PSPs."
                        buttonText="Book a Panama FinTech License Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const testimonialsData = [
    {
        quote: "We registered our payment company in Panama. Offshore Advisory managed incorporation and PSP licensing quickly.",
        author: "Diego M.",
        role: "Payment Services CEO"
    },
    {
        quote: "Panama was the right choice for our remittance platform. Offshore Advisory helped us add crypto payments under the new law.",
        author: "Sofia R.",
        role: "FinTech Founder"
    }
];

const faqData = [
    {
        question: "Does Panama have EMI licenses like Malta/Cyprus?",
        content: [
            { type: "answer", text: "Not exactly — Panama regulates remittances and fintech under MSB/payment service laws, not PSD2." },
        ],
    },
    {
        question: "What is the capital requirement?",
        content: [
            { type: "answer", text: "Usually USD 100k–250k depending on service scope." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "Around 3–6 months, faster than EU EMI." },
        ],
    },
    {
        question: "Can fintechs in Panama offer crypto payments?",
        content: [
            { type: "answer", text: "Yes — crypto payments and wallets are covered under Panama’s 2022 Digital Asset Law." },
        ],
    },
    {
        question: "Who regulates fintechs in Panama?",
        content: [
            { type: "answer", text: "The Ministry of Commerce & Industries and ISR-SNF for non-financial entities." },
        ],
    },
];
